/** @file frameSeek: puts a puppet instance on one frame of a clip, paused (the editor's playhead seek). */
import type { PuppetInstance } from '@zilo/pose3d-runtime-babylon/instance/puppetInstanceTypes';

/**
 * `play(clip, { restart: true, blend: 0 })` (no fade from the previous pose), `setPaused(true)`, then
 * `stepFrames(frame)`; the next `update(0, camera)` draws that frame. No events fire while scrubbing.
 */
export function frameSeek(instance: Pick<PuppetInstance, 'play' | 'setPaused' | 'stepFrames'>, clip: string, frame: number): void {
  instance.play(clip, { restart: true, blend: 0 });
  instance.setPaused(true);
  if (frame > 0) instance.stepFrames(frame);
}
